import { request } from '@/utils/infrastructure/communication';
import _ from 'lodash';

const controller = new AbortController();
const { signal } = controller;

const getPortalConfig = () => {
  const value = localStorage.getItem('x-auth-companyPortalConfig');
  if (value) {
    try {
      return JSON.parse(value);
    } catch (e) {}
  }
  return false;
};

export async function authLogin({ route, headers, ...params }) {
  return request(route || '/auth', {
    method: 'POST',
    credentials: 'include',
    data: params,
    headers,
    signal,
  });
}

export async function authPartyLogin({ headers, isSsoFlow, ssoClientId, ...params }) {
  return request(`/auth/${params.username}`, {
    method: 'POST',
    credentials: 'include',
    data: {
      ...params,
      ...(isSsoFlow && { isSsoFlow: true }),
      ...(isSsoFlow && ssoClientId && { ssoClientId }),
    },
    ...(headers && { headers }),
    signal,
  });
}

export async function sendTwoFactorAuthCode(data) {
  const portal = getPortalConfig();

  return request('/auth/sendTwoFactorAuthCode', {
    method: 'POST',
    data,
    ...(portal && {
      headers: { portalId: portal.id },
    }),
    signal,
  });
}

export async function validateSecurityCode(data) {
  const portal = getPortalConfig();

  return request('/auth/validateCode', {
    method: 'POST',
    data,
    ...(portal && {
      headers: { portalId: portal.id },
    }),
    signal,
  });
}

export async function authRefreshToken(token) {
  const { accessToken, refreshToken } = _.isString(token) ? JSON.parse(token) : token;
  const portal = getPortalConfig();

  return request('/auth/refreshToken', {
    method: 'POST',
    data: { accessToken, refreshToken },
    ...(portal && {
      headers: { portalId: portal.id },
    }),
    signal,
  });
}

export async function accountConfirm({ token }) {
  return request('/auth/confirmAccount', {
    method: 'POST',
    data: { token },
    signal,
  });
}

export async function authLogout() {
  return request('/auth/logout', {
    method: 'POST',
    signal,
  });
}

export async function validateSsoClient({ clientId, redirectUrl }) {
  return request('/auth/sso/validateClient', {
    method: 'POST',
    data: { clientId, redirectUrl },
    signal,
  });
}
